import { SwipeableDrawer } from '@mui/material';
import React, { useEffect } from 'react'

type Props = {
    children?: React.ReactNode;
    open: boolean;
    handleClose: () => void;
    px?: number;
    py?: number;
}

const MobileDrawerModal = (props: Props) => {
    const [height, setHeight] = React.useState(0);

    useEffect(() => {
        if (global.window != null) {
            setHeight(global.window.innerHeight)
        };
    }, [])
    return (
        <SwipeableDrawer
            anchor="bottom"
            open={props.open}
            onClose={props.handleClose}
            onOpen={() => { }}
            disableSwipeToOpen={true}
            PaperProps={{
                sx: {
                    background: "transparent",
                }
            }}
        >
            <div className="bg-primary rounded-t-[12px] pt-3">
                <div className={`bg-white overflow-auto ${props.px != null ? props.px : "4"} ${props.py != null ? props.py : "4"}`} style={{ maxHeight: `${height * 0.85}px` }}>
                    {props.children}
                </div>
            </div>
        </SwipeableDrawer>
    )
}

export default MobileDrawerModal